import { createBuilder } from "@cdv/jazz-validation";

export const builder = createBuilder();
